module.exports = __webpack_public_path__ + "static/img/thinking_swiper_one.93056ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activityforecast2024/thinking_swiper_one.png
// module id = a5k2
// module chunks = 0